import { createRoutine } from "redux-saga-routines";

export const loadAll = createRoutine("CHECK/LOAD_ALL");
